export default "__VITE_ASSET__da23591b__"